var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullscreen-loader"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"white","size":70,"width":7}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }